import { connect, useDispatch } from "react-redux";

import MediaContentCreate from "./mediaContentCreate";
import MediaContentEdit from "./mediaContentEdit";
import { useState, useEffect } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  getMediaContents,
  getMediaContent,
  deleteMediaContent,
} from "../../../../../action/masters/mediaContentActionCreator";
import { baseURL } from "../../../../../constants/commonConstants";
import {
  alertConstants,
  getAlertData,
} from "../../../../../helper/sweet-alert";
import {
  IMediaContentIndex,
  IMediaContentData,
} from "../../../../../models/master/mediaContent";
import { setMediaContents } from "../../../../../store/slices/master/mediaContentSlice";
import ReactModal from "react-modal";
import LoaderSpinner from "../../../../../common-components/loader";

const MediaContentIndex = (props: IMediaContentIndex) => {
  const {
    getMediaContents,
    mediaContents,
    getMediaContent,
    mediaContent,
    deleteMediaContent,
  } = props;
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  const handleCreateOpen = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  const editItem = async (id: number) => {
    handleEditOpen();
    setIsEditLoading(true)
    try {
      await getMediaContent(id);
    } finally {
      setIsEditLoading(false)
    }
  };

  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      setShowAlert(false);
      setIsDelete(false);
      deleteMediaContent(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getAllMediaContents();
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllMediaContents = async () => {
    setIsLoading(true);
    try {
      await getMediaContents();
    }
    finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllMediaContents();
    return () => {
      dispatch(setMediaContents([]));
    };
  }, []);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Media Contents</h2>
          <a
            href="javascript:void(0)"
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#addnewbuttons"
            onClick={handleCreateOpen}
          >
            <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
            Add New
          </a>
        </div>

        <ul className="d-flex gap-3 flex-wrap mt-28">
          {isLoading ? (
            <LoaderSpinner />
          ) : mediaContents && mediaContents.length > 0 ? (
            mediaContents.map((mediaContent: IMediaContentData) => {
              return (
                <li className="admin-card">
                  <div className="top">
                    <div className="btn-flex">
                      <button
                        className="btn-edit"
                        onClick={() => editItem(mediaContent.id ?? 0)}
                      >
                        <img src="/assets/images/icon/edit-wh.svg" alt="" />
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteItem(mediaContent.id ?? 0)}
                      >
                        <img src="/assets/images/icon/trash-wh.svg" alt="" />
                      </button>
                    </div>
                  </div>
                  <a href={mediaContent.url} target="_blank">
                    <div className="btm">
                      <div className="img">
                        <img
                          src={
                            mediaContent.image
                              ? baseURL + mediaContent.image
                              : ""
                          }
                        />
                      </div>
                      <h2>{mediaContent.title}</h2>
                    </div>
                  </a>
                </li>
              );
            })
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>

      <ReactModal
        isOpen={showCreate}
        onRequestClose={handleCreateClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
      >
        <MediaContentCreate
          setShowCreate={handleCreateClose}
          getAllMediaContents={() => getAllMediaContents()}
        />
      </ReactModal>

      {isEditLoading ? (
        <LoaderSpinner />
      ) : (
        <ReactModal
          isOpen={showEdit}
          onRequestClose={handleEditClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
        >
          <MediaContentEdit
            setShowEdit={handleEditClose}
            getAllMediaContents={() => getAllMediaContents()}
            mediaContent={mediaContent}
          />
        </ReactModal>
      )}

      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={isDelete}
        onCancel={() => {
          setShowAlert(false);
          setIsDelete(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={isDelete ? "Yes" : "Ok"}
      />
    </>
  );
};

const mapDispatchToProps = {
  getMediaContents: () => getMediaContents(),
  getMediaContent: (id: number) => getMediaContent(id),
  deleteMediaContent: (id: number, callBack: Function) =>
    deleteMediaContent(id, callBack),
};

function mapStateToProps(state: any) {
  return {
    mediaContents: state.mediaContent.mediaContents,
    mediaContent: state.mediaContent.mediaContent,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MediaContentIndex);
